const translations = {
  "en": {
    "Complete": "Complete",
    "Free": "Free",
    "Pricing": "Pricing",
    "Settings": "Settings",
    "Upgrade": "Upgrade"
  },
  "zh-tw": {
    "Complete": "Complete",
    "Free": "免費",
    "Pricing": "定價",
    "Settings": "設定",
    "Upgrade": "升級"
  }
};

export default translations;
